import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    const token = localStorage.getItem("plw_token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      localStorage.removeItem("plw_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  const login = async (userId, pin) => {
    const { data } = await api.post("/auth/login", { user_id: userId, pin });
    localStorage.setItem("plw_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("plw_token");
    // Purge session-scoped desk state so the next person to log in
    // doesn't inherit the previous Reception's "Serving" name.
    sessionStorage.removeItem("plw_serving_requester");
    setUser(null);
  };

  const isManager = user && (user.role === "warehouse_manager" || user.role === "operations_manager");

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, isManager, refresh: fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be inside AuthProvider");
  return ctx;
};
